import {
  AuthContext,
  CommonContext,
  Game,
  snakify,
  User,
} from '@repo-level/core-front';
import { useContext, useMemo } from 'react';
import { isPlayerFieldsFilled } from './profile';

export const usePlayerFieldsStatus = (
  provider?: Game['provider']
): {
  requiredFields: (keyof User)[];
  isAllFieldsFilled: boolean;
  missingFields: string[];
} => {
  const { playerFields } = useContext(CommonContext);
  const { user } = useContext(AuthContext);

  return useMemo(() => {
    if (!user || !playerFields || !provider) {
      return {
        requiredFields: [],
        isAllFieldsFilled: false,
        missingFields: [],
      };
    }

    const snakeUser = snakify(user) as User;
    const raw = Array.isArray(playerFields.contexts?.[provider])
      ? playerFields.contexts?.[provider]
      : [];

    const required = raw.filter((k): k is keyof User => k in snakeUser);

    const { isAllFieldsFilled, missingFields } = isPlayerFieldsFilled(
      snakeUser,
      required
    );

    return { requiredFields: required, isAllFieldsFilled, missingFields };
  }, [user, playerFields, provider]);
};
